import { ScandataFile } from '../../scandata/scandata-file.model';
import { ScandataModel } from '../../scandata/scandata.models';

export interface ScanDownload {
  scandataModel: ScandataModel;
  files: FileDownload[];
  expanded: boolean;
}

export interface FileDownload {
  scandataModelId: string;
  scandataFile: ScandataFile;
  downloadProgress?: DownloadProgress;
  icon: string;
}

export interface DownloadProgress {
  status: DownloadStatus;
  percentageComplete: number;
  content: Blob | null;
}

export enum DownloadStatus {
  Pending = 'Pending',
  Busy = 'Busy',
  Complete = 'Complete',
  Failed = 'Failed',
}
